const Vue = window.Vue;

Vue.component('BulletPointsWidget', () => import('./app/components/BulletPointsWidget.vue'));
